module.exports = __webpack_public_path__ + "static/img/prize3.d343280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/prize3.png
// module id = sQVW
// module chunks = 1